export default "__VITE_ASSET__nR6UguF7__"